import React from 'react';
import { fulfilledCssClass } from '@jjj/components';
import { TextCell } from './helperCells';
import { getPercentage } from '../../helpers/utility';

const isJobCanceled = (status = '') => {
  switch (status.toLocaleLowerCase()) {
    case 'canceled_by_admin':
    case 'canceled':
      return true;
    default:
      return false;
  }
};

const generateFulfilledCell = (job, url) => {
  const { workers_required, workers_assigned, backup_workers_assigned, backup_workers_required, status } = job;

  const jobIsCanceled = isJobCanceled(status?.id);
  const workers = getPercentage(workers_assigned, workers_required);
  const backupWorkers = getPercentage(backup_workers_assigned, backup_workers_required);
  const workersFulfillment = jobIsCanceled ? workers_required : `${workers_assigned}/${workers_required}`;
  const backupWorkersFulfillment = `${backup_workers_assigned}/${backup_workers_required}`;
  const backupExists = backupWorkers !== null;

  return TextCell(
    <div>
      {backupExists && (
        <p
          className={fulfilledCssClass({
            percent: workers,
            isCancelled: isJobCanceled(status?.id),
            isMulti: true,
            hasWorkersRequired: workers_required,
          })}
        >
          {workersFulfillment}
        </p>
      )}
      {backupExists && (
        <p
          className={fulfilledCssClass({
            percent: backupWorkers,
            isCancelled: isJobCanceled(status?.id),
            isMulti: true,
            hasWorkersRequired: backup_workers_required,
          })}
        >
          {backupWorkersFulfillment}
        </p>
      )}
      {!backupExists && (
        <p
          className={fulfilledCssClass({
            percent: workers,
            isCancelled: isJobCanceled(status?.id),
            isMulti: false,
            hasWorkersRequired: workers_required,
          })}
        >
          {workersFulfillment}
        </p>
      )}
    </div>,
    url,
  );
};
export { generateFulfilledCell };
